export default {
	i18n: {
		messages: {
			de: require('@/i18n/de/de_ausbildungsinhalte.json'),
			en: require('@/i18n/en/eng_ausbildungsinhalte.json')
		}
	}
}
